// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file event_type.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file event_type.proto.
 */
export const file_event_type: GenFile = /*@__PURE__*/
  fileDesc("ChBldmVudF90eXBlLnByb3RvEgtncnBjLmFwaS52MSJHCglFdmVudFR5cGUSCgoCaWQYASABKAMSDAoEdHlwZRgCIAEoCRIMCgRuYW1lGAMgASgJEhIKCmlzX2RlZmF1bHQYBCABKAhCBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.EventType
 */
export type EventType = Message<"grpc.api.v1.EventType"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;
};

/**
 * Describes the message grpc.api.v1.EventType.
 * Use `create(EventTypeSchema)` to create a new message.
 */
export const EventTypeSchema: GenMessage<EventType> = /*@__PURE__*/
  messageDesc(file_event_type, 0);

